import { createSlot } from "lib/@components/slot/create-slot"

export const AuthoringHomeTitle = createSlot("AuthoringHomeTitle")
export const AuthoringHomeTile = createSlot("AuthoringHomeTile")
